import React from "react"
import styles from "./yellow-box.module.scss"
import classNames from "classnames"

export default () => {
  return <div className={classNames(styles.yellowBox)}></div>
}
